export const BookJson = [
  {
    BookName: "OET-Practice-Book",
    Book_Cover: "/OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
    Pages: 229,
    Rating: "4.5",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },
  {
    BookName: "Best-Preparation-IELTS-Speaking",
    Book_Cover:
      "/Best-Preparation-IELTS-Speaking/347012850-The-Best-Preparation-For-IELTS-Speaking-pdf_page-0001.jpg",
    Pages: 316,
    PagesLength: "0001",
    Rating: "4.8",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },
  {
    BookName: "IELTS-Strategies-IELTS-Reading",
    Book_Cover:
      "/IELTS-Strategies-IELTS-Reading/363354990-Practical-IELTS-Strategies-1-IELTS-Reading_001.jpg",
    Pages: 194,
    Rating: "4.6",
    PagesLength: "001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "IELTS-Speaking-Strategies",
    Book_Cover:
      "/IELTS-Speaking-Strategies/434300695-IELTS-Speaking-Strategies_page-0001.jpg",
    Pages: 155,
    Rating: "4.6",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "Tips-for-PTE-Academic-Exam",
    Book_Cover:
      "/Tips-for-PTE-Academic-Exam/403460350-Tips-for-PTE-Academic-Exam_page-0001.jpg",
    Pages: 6,
    Rating: "4.9",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },
  {
    BookName: "Secret-IELTS-E-Book",
    Book_Cover:
      "/Secret-IELTS-E-Book/534858816-11-Proven-Secret-IELTS-E-Book-June_page-0001.jpg",
    Pages: 9,
    Rating: "4.9",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "IELTS-Vocabulary-2024-2025",
    Book_Cover:
      "/IELTS-Vocabulary-2024-2025/812965023-IELTS-Vocabulary-2024-2025_page-0001.jpg",
    Pages: 19,
    Rating: "4.9",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "IELTS-Cheat-Sheet",
    Book_Cover: "/IELTS-Cheat-Sheet/791790722-IELTS-Cheat-Sheet_page-0001.jpg",
    Pages: 10,
    Rating: "4.9",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "IELTS-Support-Tools",
    Book_Cover:
      "/IELTS-Support-Tools/697926404-IELTS-Support-Tools_page-0001.jpg",
    Pages: 22,
    Rating: "4.9",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "Get-IELTS-Band-9",
    Book_Cover: "/Get-IELTS-Band-9/597408871-get-ielts-band-9_page-0001.jpg",
    Pages: 43,
    Rating: "4.9",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "IELTS-Listening",
    Book_Cover: "/IELTS-Listening/072401c2-9163-4a4b-a727-dd417a836864-001.jpg",
    Pages: 5,
    Rating: "4.9",
    PagesLength: "001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "Writing-Task-Problems-And-Solutions",
    Book_Cover:
      "/Writing-Task-Problems-And-Solutions/576881488-writing-task-2-problems-and-solutions_page-0001.jpg",
    Pages: 13,
    Rating: "4.9",
    PagesLength: "001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "Fighter-Writing-Lesson",
    Book_Cover:
      "/Fighter-Writing-Lesson/756034708-Fighter-5-Writing-Lesson-2-Pie-Mixed-Charts-1-p.jpg",
    Pages: 58,
    Rating: "4.9",
    PagesLength: "p",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "Listening-IELTS-Materials",
    Book_Cover:
      "/Listening-IELTS-Materials/732231057-Listening-IELTS-Materials-Jan-June-24_page-0001.jpg",
    Pages: 184,
    Rating: "5.0",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "IELTS-Preparation-Guide",
    Book_Cover:
      "/IELTS-Preparation-Guide/667335499-IELTS-Preparation-Guide-2023-May_page-0001.jpg",
    Pages: 37,
    Rating: "4.8",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "Tips-for-IELTS-Listening",
    Book_Cover:
      "/Tips-for-IELTS-Listening/631736161-Tips-for-IELTS-Listening_page-0001.jpg",
    Pages: 12,
    Rating: "4.4",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },
  {
    BookName: "IELTS-Writing-Task",
    Book_Cover:
      "/IELTS-Writing-Task/3f2d17a8-353c-42f0-a1de-60425cec9b57-p.jpg",
    Pages: 90,
    Rating: "4.5",
    PagesLength: "p",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "OET-Practice-Book/Official-OET-Practice-Book-1_page-0001.jpg",
  },

  {
    BookName: "English-Grammar",
    Book_Cover:
      "/English-Grammar/English%20Grammar%20in%20Use%20by%20Raymond%20Murphy%20(z-lib.org)_page-0001.jpg",
    Pages: 394,
    Rating: "4.5",
    PagesLength: "0001",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "/English-Grammar/English%20Grammar%20in%20Use%20by%20Raymond%20Murphy%20(z-lib.org)_page-0001.jpg",
  },

  {
    BookName: "Visual-Phrasal-Verbs",
    Book_Cover:
      "/Visual-Phrasal-Verbs/644334482-Visual-Phrasal-Verbs-images-p.jpg",
    Pages: 328,
    Rating: "4.2",
    PagesLength: "p",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "/Visual-Phrasal-Verbs/644334482-Visual-Phrasal-Verbs-images-0.jpg",
  },

  {
    BookName: "Everyone-Business-English-Course",
    Book_Cover:
      "/Everyone-Business-English-Course/529661980-English-for-Everyone-Business-English-Course-Book-Level-2-Dorling-Kindersley-p.jpg",
    Pages: 192,
    Rating: "4.6",
    PagesLength: "p",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "/Everyone-Business-English-Course/529661980-English-for-Everyone-Business-English-Course-Book-Level-2-Dorling-Kindersley-1.jpg",
  },

  {
    BookName: "English-Grammar-Guide-Practice-Book",
    Book_Cover:
      "/English-Grammar-Guide-Practice-Book/492616174-English-for-Everyone-English-Grammar-Guide-Practice-Book-p.jpg",
    Pages: 320,
    Rating: "4.5",
    PagesLength: "p",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "/English-Grammar-Guide-Practice-Book/492616174-English-for-Everyone-English-Grammar-Guide-Practice-Book-p.jpg",
  },
  {
    BookName: "Common-Phrasal-Verbs",
    Book_Cover:
      "/Common-Phrasal-Verbs/163586359-200-Common-Phrasal-Verbs-p.jpg",
    Pages: 13,
    Rating: "4.6",
    PagesLength: "p",
    URL:
      process.env.REACT_APP_DOC +
      "/Books/" +
      "/Common-Phrasal-Verbs/163586359-200-Common-Phrasal-Verbs-1.jpg",
  },
];
